export const getMunicipalityAppAccess = ({ has_sod_app, has_analytics_app, municipality_sections }) => {
  const sections = municipality_sections || []
  const hasSodSection = sections.some((ms) => ms.section?.abbreviation === 'SOD')
  const hasAnalyticsSection = sections.some((ms) => ms.section?.abbreviation !== 'SOD')
  return {
    canAccessSod: has_sod_app && hasSodSection,
    canAccessAnalytics: has_analytics_app && hasAnalyticsSection,
  }
}

export const isAccountingSwitcher = ({ user_type, switchable_municipalities }) =>
  user_type === 'accounting' && (switchable_municipalities || []).length > 1

export const canSwitchMunicipality = (user) => Boolean(user.is_admin) || isAccountingSwitcher(user)
